export class DigitalLeadBg {
	public phone?: string
	public email?: string
	public first_name?: string
	public middle_name?: string
	public last_name?: string
	public empty_middle_name?: boolean
	public is_director?: boolean
	public attorney?: boolean
}
